import { render } from "./QuestionFormBlock.vue?vue&type=template&id=0ff53d68"
import script from "./QuestionFormBlock.vue?vue&type=script&lang=js"
export * from "./QuestionFormBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__